import { render } from "./NewBenefitQuote.vue?vue&type=template&id=62bf0273&scoped=true"
import script from "./NewBenefitQuote.vue?vue&type=script&lang=js"
export * from "./NewBenefitQuote.vue?vue&type=script&lang=js"

import "./NewBenefitQuote.vue?vue&type=style&index=0&id=62bf0273&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-62bf0273"]])

export default __exports__